import {
  ACTION_TYPE_INSURE_PACKAGE,
  ACTION_TYPE_REQUEST_CONFIRMATION,
  ACTION_TYPE_SET_CUSTOMS_CONTENT_TYPE,
  ACTION_TYPE_SET_INTERNATIONAL_NON_DELIVERY,
} from '../../../../constants/action-types';

import InsuranceOptions from './single-select-options/insurance-providers';
import ConfirmationOptions from './single-select-options/delivery-confirmations';
import CustomsContent from './single-select-options/customs-content-types';
import InternationalNonDeliveryOptions from './single-select-options/international-non-delivery-types';

export const AllowedValuesByActionType = (actionType, state) => {
  const typeToActionsMap = {
    [ACTION_TYPE_INSURE_PACKAGE]: InsuranceOptions(state),
    [ACTION_TYPE_REQUEST_CONFIRMATION]: ConfirmationOptions(state),
    [ACTION_TYPE_SET_CUSTOMS_CONTENT_TYPE]: CustomsContent,
    [ACTION_TYPE_SET_INTERNATIONAL_NON_DELIVERY]: InternationalNonDeliveryOptions,
  };

  return typeToActionsMap[actionType] || [];
};
